module.exports = __webpack_public_path__ + "static/media/enumeration.e1f4ee70.svg";